module.exports = __webpack_public_path__ + "static/media/imp.f6f20bad.svg";